import Loadable from 'my-components/Loadable';

import PlayerLoader from './PlayerLoader';

export { default as AspectRatioWrapper } from './AspectRatioWrapper';
export { default as PlayerLoader } from './PlayerLoader';

export default Loadable(() => import(/* webpackChunkName: "player" */ './Player'), {
  fallback: <PlayerLoader />,
});
